<template>
  <div id="tabbar">
    <div class="container">
      <div class="logo">
        <img src="../assets/images/logo.png" />
      </div>
      <div class="nav">
        <ul>
          <li>
            <router-link tag="a" to="/home" href="javascript;:">首页</router-link>
          </li>
          <li>
            <router-link tag="a" to="/product" href="javascript;:">
              产品展示
              <i class="el-icon-arrow-down icon"></i>
            </router-link>
            <ul class="dropdown_menu">
              <li>
                <router-link tag="a" to="/product/wanwu" href="javascript;:">万物物联</router-link>
              </li>
              <li>
                <router-link tag="a" to="/product/robot" href="javascript;:">智能机器人</router-link>
              </li>
            </ul>
          </li>
          <li>
            <router-link tag="a" to="/cases" href="javascript;:">成功案例</router-link>
          </li>
          <li>
            <router-link tag="a" to="/about" href="javascript;:">
              关于远达
              <i class="el-icon-arrow-down icon"></i>
            </router-link>
            <ul class="dropdown_menu">
              <li>
                <router-link tag="a" to="/about/brief" href="javascript;:">公司简介</router-link>
              </li>
              <li>
                <router-link tag="a" to="/about/events" href="javascript;:">大事记</router-link>
              </li>
              <li>
                <router-link tag="a" to="/about/honour" href="javascript;:">荣誉与认证</router-link>
              </li>
              <li>
                <router-link tag="a" to="/about/contact" href="javascript;:">联系我们</router-link>
              </li>
            </ul>
          </li>
          <li>
            <router-link tag="a" to="/infomation" href="javascript;:">物联资讯</router-link>
          </li>
          <li>
            <router-link tag="a" to="/made" href="javascript;:">个性化定制</router-link>
          </li>
        </ul>
      </div>
      <div class="search">
        <el-input placeholder="搜索" suffix-icon="el-icon-search" size="mini"></el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
#tabbar {
  position: fixed;
  height: 90px;
  width: 100%;
  display: flex;

  display: -ms-flex; /* 兼容IE */

  justify-content: center;

  align-items: center;

  background: rgba(255, 255, 255, 1);
  z-index: 1000;
  .container {
    width: 1200px;
    display: flex;
    align-items: center;
    position: relative;
    min-width: 1200px;
    .logo {
      margin-right: 54px;
      width: 13%;
      height: 40px;
      display: flex;
      align-items: center;
      img {
        width: 100%;
      }
    }
    .nav ul {
      display: flex;
      position: relative;
      width: 100%;

      li {
        &:hover .dropdown_menu {
          display: block;
        }
        &:hover .icon {
          transform: rotateZ(180deg);
          color: rgba(38, 172, 255, 1);
        }
        &:hover > a {
          color: rgba(38, 172, 255, 1);
          font-weight: bold;
        }
        .router-link-active {
          color: rgba(38, 172, 255, 1);
          font-weight: bold;
          .icon {
            color: rgba(38, 172, 255, 1);
          }
        }
        .dropdown_menu {
          position: absolute;
          width: 120px;
          padding: 10px 0;
          font-size: 14px;
          display: none;
          z-index: 100;
          background: rgba(255, 255, 255, 1);

          li {
            height: 32px;
            line-height: 32px;
            .router-link-active {
              background-color: rgb(233, 247, 255);
              font-weight: 400;
            }
          }
          a {
            display: block;
            padding: 5px 10px;
          }
        }
      }

      li a {
        padding: 0 15px;
        font-size: 16px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
      }
    }
    .search {
      position: absolute;
      right: 0;
      bottom: 3px;
    }
    .search .el-input/deep/.el-input__inner {
      width: 160px;
      height: 32px;
      background: rgba(242, 242, 243, 1);
      transition: all 0.3s;
      &:hover {
        width: 200px;
      }
    }
  }
}
</style>